import { Grid, Tooltip, Typography } from "@mui/material";

import { CheckCircleIcon } from "@phosphor-icons/react/dist/csr/CheckCircle";
import { InfoIcon } from "@phosphor-icons/react/dist/csr/Info";
import { VALID_SPECIAL_CHARS_REGEX, validatePasswordPolicy } from "../../lib/Util";

const PasswordCheckerMessage = ({
  text,
  success,
  feedback,
  fixedWidth,
}: {
  text: string;
  success: boolean;
  feedback?: string;
  fixedWidth?: boolean;
}) => {
  return (
    <Grid container size={{ xs: 5, sm: fixedWidth ? 5 : 12, md: 5 }} wrap="nowrap" sx={{ alignItems: "center" }}>
      <CheckCircleIcon color={success ? "success" : "disabled"} />
      <Typography
        noWrap
        sx={{ ml: 1, mr: 0.2, color: success ? "accentSuccess40.main" : "text30.main", overflow: "visible" }}
      >
        {text}
      </Typography>
      {feedback ? (
        <Tooltip title={feedback} color="disabled" arrow>
          <InfoIcon fontSize="small" />
        </Tooltip>
      ) : null}
    </Grid>
  );
};

const PasswordCheckers = ({ password, fixedWidth }: { password: string; fixedWidth?: boolean }) => {
  const { errors, feedback } = validatePasswordPolicy(password);
  const correctLength = !errors.includes("8 to 128 characters");
  const hasUppercase = !errors.includes("uppercase");
  const hasLowercase = !errors.includes("lowercase");
  const hasDigit = !errors.includes("digit");
  const hasSpecialChar = !errors.includes("1 special character");
  const strongEnough = !errors.includes("Password isn't strong enough");

  return (
    <Grid container spacing={1}>
      <PasswordCheckerMessage text="8 to 128 characters" success={correctLength} fixedWidth={fixedWidth} />
      <PasswordCheckerMessage text="1 Uppercase" success={hasUppercase} fixedWidth={fixedWidth} />
      <PasswordCheckerMessage text="1 Lowercase" success={hasLowercase} fixedWidth={fixedWidth} />
      <PasswordCheckerMessage text="1 Digit" success={hasDigit} fixedWidth={fixedWidth} />
      <PasswordCheckerMessage
        text="1 Special character"
        success={hasSpecialChar}
        fixedWidth={fixedWidth}
        feedback={!hasSpecialChar ? `Valid special characters are ${VALID_SPECIAL_CHARS_REGEX.source}` : undefined}
      />
      <PasswordCheckerMessage
        text="Strong"
        success={strongEnough}
        feedback={!strongEnough ? feedback : undefined}
        fixedWidth={fixedWidth}
      />
    </Grid>
  );
};

export { PasswordCheckers };
